/**
 * continuityMotionSemantics
 *
 * Deterministic CSS properties for continuity transition motion.
 * Communicates: degraded → stabilized pulse, overlay fade, refusal settle.
 */

import { TRANSITION_CONTINUITY_OVERLAY, TRANSITION_CONTINUITY_PULSE, TRANSITION_REFUSAL_SETTLE } from './motionTokens.js';

/**
 * Continuity overlay fade style.
 * Used for continuity state markers appearing/disappearing on timeline rows.
 */
export function continuityOverlayStyle(visible: boolean, color: string): React.CSSProperties {
  return {
    opacity: visible ? 1 : 0,
    transition: TRANSITION_CONTINUITY_OVERLAY,
    backgroundColor: visible ? `${color}15` : 'transparent',
  };
}

/**
 * Continuity state pulse style.
 * Soft single pulse when degraded → stabilized.
 */
export function continuityPulseStyle(marker: string): React.CSSProperties {
  const isDegraded = marker === 'degraded' || marker === 'interrupted';
  return {
    boxShadow: isDegraded ? '0 0 0 0 rgba(200, 134, 10, 0.0)' : '0 0 0 4px rgba(61, 122, 61, 0.15)',
    transition: TRANSITION_CONTINUITY_PULSE,
  };
}

/**
 * Refusal marker settle style.
 * Refusal markers settle rather than flash.
 */
export function refusalSettleStyle(isRefusal: boolean): React.CSSProperties {
  return {
    opacity: isRefusal ? 1 : 0,
    transform: isRefusal ? 'translateY(0)' : 'translateY(-2px)',
    transition: TRANSITION_REFUSAL_SETTLE,
  };
}

/**
 * Continuity dot appear style.
 * Small dot fades in calmly when continuity marker present.
 */
export function continuityDotAppearStyle(visible: boolean, color: string): React.CSSProperties {
  return {
    opacity: visible ? 1 : 0,
    transform: visible ? 'scale(1)' : 'scale(0.6)',
    transition: `opacity 180ms ease-out, transform 180ms ease-out`,
    backgroundColor: color,
  };
}
